module.exports = __webpack_public_path__ + "images/home/product/features-timeline-7e6fb0a611e91855f59392db9188f51f.png";